import React from 'react';
import {useStationForecast} from '../hooks';
import {Forecast} from '../utils';

type MandatoryProps = {
  stationId: number;
};

const withForecastNextHours =
  <T extends MandatoryProps = MandatoryProps>(
    Component: React.ComponentType<T>,
  ) =>
  ({stationId, ...props}: T) => {
    const {
      forecastData: {
        data: {hourly},
        metadata,
      },
    } = useStationForecast(stationId);

    const hourlyForecast = React.useMemo(
      () => Forecast.nextHours(hourly),
      [hourly],
    );

    const forecastModel = React.useMemo(
      () =>
        Forecast.SupportedForecastModelList.find(
          (item) =>
            item.serverId.forecastModel === metadata.forecast_model &&
            (item.serverId.meshSize === metadata.mesh_size ||
              item.serverId.meshSize === null),
        ),
      [metadata],
    );

    return (
      <Component
        hourlyForecast={hourlyForecast}
        forecastModel={forecastModel}
        forecastModelMetadata={metadata}
        stationId={stationId}
        {...(props as T)}
      />
    );
  };

export default withForecastNextHours;
